import React from 'react';
import moment from "moment";

import SpotlioIcon from '../../Icon';
import Currency from '../../Currency';

import Bundles from "./bundles";

import IntlMessage from '../../../LocaleEngine';

import { getSystemSettings } from '../../../utils/SettingsRetriever';
import getDateFormat from "../../../utils/DateFormatRetriever";

export default function Cart(props){
    const { index, item, agrupation } = props;

    let bundleUpselling = true;
    if(getSystemSettings().app.bundles && getSystemSettings().app.bundles.enabledOnCart === false){
        bundleUpselling = false;
    }

    function getCurrency(displayType){
        let currency = null;
        switch (displayType){
            case 1:
                currency = (
                    <Currency displayType={displayType} strikeThrough={true} onlyOriginal={true} float={true} value={item.OriginalPrice} />
                )
            break;
            case 2:
                currency = (
                    <React.Fragment>
                        {(item.OriginalPrice > 0 && item.OriginalPrice > item.Price) ?<Currency displayType={displayType} strikeThrough={true} onlyOriginal={true} float={true} value={item.OriginalPrice} /> : null}
                        <Currency onlyOriginal={true} float={true} value={item.Price} />
                    </React.Fragment>
                )
            break;
            case 3:
            break;
            default:
            break;
        }
        return currency;
    }
    return (
        window.innerWidth > 991
        ? <div className="cartItem">
            <div key={"item"+index} className="product">
                {
                    item.ReservationDate !== ''
                    ?
                    <div className="confirmed"><IntlMessage id="activities.cell.option.head.confirmed" /></div>
                    :
                    null
                }
                <div className="multimedia" data-id={agrupation.id} data-supercategoryid={agrupation.supercategoryid} data-name={agrupation.name}>
                    <SpotlioIcon icon={agrupation.icon} />
                </div>
                <div className="content">
                    <div className="supplierName">{item.SupplierName}</div>
                    <div className="productName">{item.ProductName}</div>
                    <div className="date"><span><IntlMessage id="cart.labels.date" />: </span>{moment.utc(item.ArrivalDate).format(getDateFormat())}</div>
                    <div className="qty"><span><IntlMessage id="cart.labels.quantity" />: </span>{item.Quantity}</div>
                </div>
                <div className="sideinfo">
                    <div className="price">
                        {item.PackageDisplayType ? getCurrency(item.PackageDisplayType) : <Currency float={true} value={item.Price}/>}
                        {item.PackageName ?
                        <React.Fragment>
                            {item.OriginalPrice - item.Price > 0 ? <div className="savings"><IntlMessage id={
                                            getSystemSettings().app && getSystemSettings().app.cart && getSystemSettings().app.cart.savingsText 
                                            ?
                                            getSystemSettings().app && getSystemSettings().app.cart && getSystemSettings().app.cart.savingsText
                                            :
                                            "activities.cart.lodge.savings"
                                        } />: <Currency onlyOriginal={true} float={true} value={parseFloat(item.OriginalPrice).toFixed(2) - parseFloat(item.Price).toFixed(2)}/></div> : null}
                            {/* <p>{item.PackageName}</p> */}
                        </React.Fragment>
                        : null}
                    </div>
                    {item.PackageRequiredItem === 0 && !item.NoDelete ?
                    <div onClick={() => props.deleteItem(item, true)} className="remove">
                        <SpotlioIcon size={16} icon={"feather-trash-2"} />
                        <span><IntlMessage id="cart.remove_item.buttons.remove" /></span>
                    </div>
                    :
                    <div className="required">
                        <SpotlioIcon size={16} icon={"feather-lock"} />
                        <span>Required component</span>
                    </div>
                    }
                </div>
            </div>
            {
                item.BundleRelationship && bundleUpselling
                ?
                <Bundles readOnly={props.readOnly} getBundle={props.getBundle} bundleConfig={props.bundleConfig} bundles={item.BundleRelationship} />
                :
                null
            }
        </div>
        : <>
            <div className="cartActivity">
                <div className="activityTopContent">
                    { false && // A false porque aún no llega imagen
                        <div className="activityImage" style={{backgroundImage: `url(${'AQUI LA IMAGEN'}`}} />
                    }
                    <div className="activityCaption">
                        <div className="destination">
                            {item.SupplierName}
                        </div>
                        <div className="name">
                            {item.ProductName}
                        </div>
                    </div>
                </div>
                <div className="activitySumup">
                    <div className="sumup">
                        <div className="label"><IntlMessage id="cart.labels.date" /></div>
                        <div className="value">{moment.utc(item.ArrivalDate).format('ddd, D MMM YYYY')}</div>
                    </div>
                    <div className="sumup">
                        <div className="label"><IntlMessage id="cart.labels.quantity" /></div>
                        <div className="value">{item.Quantity}</div>
                    </div>
                    <div className="sumup">
                        {item.PackageRequiredItem === 0 && !item.NoDelete
                            ? <div className="deleteButton" onClick={() => props.deleteItem(item, true)}><SpotlioIcon icon="feather-trash"/></div>
                            : <div className="required"><SpotlioIcon size={16} icon={"feather-lock"} /> Required</div>
                        }
                        <div className="currency">
                            {item.PackageDisplayType ? getCurrency(item.PackageDisplayType) : <Currency float={true} value={item.Price}/>}
                        </div>
                    </div>
                </div>
            </div>
            {
                item.BundleRelationship && bundleUpselling && !props.readOnly
                ?
                item.BundleRelationship.map((bundle) => {
                    if(bundle.FilledChildren !== 0){
                        return null;
                    }

                    return (
                        <div onClick={()=>props.getBundle(bundle)} className="bundle item">
                            [ + ] {bundle.BundleName}
                        </div>
                    )
                })
                :
                null
            }
        </>
    )
}
